var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import styles from './ButtonOptions.module.scss';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { onClickOutside } from 'src/shared/helpers/viewsHelpers';
import { IDENTIFIER_BUTTON, IDENTIFIER_BUTTON_OPTIONS } from 'src/ui/components/button/constants';
// TODO change position of popin if is outside of screen
export var ButtonOptions = function (props) {
    var _a;
    var icon = props.icon, options = props.options, identifier = props.identifier, onOptionsClick = props.onOptionsClick;
    var _b = useState(false), isOpenedOptions = _b[0], setIsOpenedOptions = _b[1];
    var buttonOptionsWrapperRef = useRef(null);
    // LIFECYCLE
    useMount(function () {
        onClickOutside(buttonOptionsWrapperRef, function () { return setIsOpenedOptions(false); });
    });
    // METHOD
    var handleOpenOptionsClick = function (e) {
        e.stopPropagation();
        setIsOpenedOptions(function (prevState) { return !prevState; });
    };
    var handleOnOptionsClick = function (e, opt) {
        e.stopPropagation();
        onOptionsClick(opt);
    };
    // CLASS
    var optionsListClassName = classNames(styles.buttonOptionsListWrapper, (_a = {},
        _a[styles.buttonOptionsListWrapperOpen] = isOpenedOptions,
        _a));
    var buttonIdentifier = identifier ? identifier : IDENTIFIER_BUTTON;
    // TODO add disabled on options
    return (_jsxs("div", __assign({ "data-test": buttonIdentifier, ref: buttonOptionsWrapperRef, className: styles.buttonOptionsWrapper }, { children: [_jsx("div", __assign({ className: styles.buttonOpenerOptions, onClick: handleOpenOptionsClick }, { children: _jsx(Icons, { icon: icon, color: COLORS.BLACK }) })), _jsx("ul", __assign({ "data-test": IDENTIFIER_BUTTON_OPTIONS, className: optionsListClassName }, { children: options.map(function (opt) { return (_jsx("li", __assign({ className: styles.optionItem, onClick: function (e) { return handleOnOptionsClick(e, opt); } }, { children: opt.label }), opt.label)); }) }))] })));
};
